import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import { list as logistsList } from "sources/books/employees";
import GroupedByLogistReport from "./groupedByLogistReport";

export default class BidsCreatedOnTimeReport extends GroupedByLogistReport {
    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Aggregated: ({ value }) => {
                switch (column.propertyName) {
                    case "BidsCreatedOnTimePercent":
                    case "BidsCount": {
                        return null;
                    }
                    default:
                        return value !== null ? <strong>{formatValue(value, column.clrType)}</strong> : "";
                }
            },
            Cell: (props) => {
                const { bidId } = props.row.values;
                const uniqueId = { [`data-${props.column.id}`.toLowerCase()]: bidId };
                const { id } = props.column;
                switch (id) {
                    case "bidsCreatedOnTimePercent":
                    case "bidsCount": {
                        return null;
                    }
                    case "createdById": {
                        const { subRows } = props.row;
                        const creatorName =
                            (subRows?.length
                                ? subRows[0].original?.creatorDisplayName
                                : props.row.original.creatorDisplayName) || "Без логиста";
                        const rowCount = !subRows ? "" : /\(\d+\)$/.test(creatorName) ? "" : ` (${subRows.length})`;
                        return (
                            <span data-car-creator-id={props.value}>
                                {creatorName}
                                {rowCount}
                            </span>
                        );
                    }
                    case "carLogistId": {
                        const { subRows } = props.row;
                        const logistName =
                            (subRows?.length
                                ? subRows[0].original?.carLogistDisplayName
                                : props.row.original.carLogistDisplayName) || "Без логиста";
                        const rowCount = !subRows ? "" : /\(\d+\)$/.test(logistName) ? "" : ` (${subRows.length})`;
                        return (
                            <span data-car-logist-id={props.value}>
                                {logistName}
                                {rowCount}
                            </span>
                        );
                    }
                    case "bidId": {
                        return (
                            <a
                                data-bidid={props.value}
                                href={paths.bidShow("bid", props.value)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {props.value}
                            </a>
                        );
                    }
                    case "createdAt":
                    case "firstStartedAt":
                    case "firstPointFactEnterDate":
                    case "firstPointPlanEnterDate": {
                        return (
                            <span {...uniqueId}>
                                {props.value ? dateTimeToView(props.value, "DD.MM.YYYY HH:mm (Z)") : ""}
                            </span>
                        );
                    }
                    default:
                        return <span {...uniqueId}>{formatValue(props.value, column.clrType)}</span>;
                }
            },
            Footer: () => this.footerVal(column),
            ...typeSpecificProps(column),
            ...(column.propertyName === "CarLogistId"
                ? {
                      Filter: reportFilterWrapper((props) => (
                          <SelectColumnFilter
                              {...props}
                              selectProps={{
                                  ...defaultMultipleSelectProps,
                                  url: logistsList,
                                  inputProps: { name: "carLogistIds" },
                                  propName: "fullNameOrEmail",
                                  components: { ValueContainer },
                              }}
                          />
                      )),
                      filter: (rows, _id, filterValue) => {
                          if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                              return rows;
                          }
                          return rows.filter((row) => filterValue.value.includes(row.values.carLogistId));
                      },
                  }
                : {}),
        };
    };

    footerVal = (column) => {
        if (!column) {
            return "";
        }
        const { footer } = this.props.data || {};
        const value = footer[columnName(column)];
        switch (columnName(column)) {
            case "bidsCount":
                return <span>{value}</span>;
            case "bidsCreatedOnTimePercent":
                return <span>{value}%</span>;
            default:
                return null;
        }
    };

    tableExtraProps = () => {
        const { columns } = this.props.data || {};
        const hiddenColumns = columns
            .filter(
                (column) =>
                    column.isAdditionalColumn ||
                    (this.props.groupByCreator
                        ? column.propertyName === "CreatorDisplayName"
                        : column.propertyName === "CarLogistDisplayName"),
            )
            .map(columnName);
        return {
            initialState: {
                groupBy: [this.props.groupByCreator ? "createdById" : "carLogistId"],
                hiddenColumns,
            },
            getRowProps: (row) => {
                if (row.isGrouped) {
                    return {};
                }
                const { bidIsCreatedOnTime } = row.values;
                if (bidIsCreatedOnTime) {
                    return { className: "tr" };
                } else {
                    return { className: "tr reports__item--red" };
                }
            },
        };
    };
}
